var map = {
	"./ar.json": "2460",
	"./de.json": "29d4",
	"./en.json": "3954",
	"./es.json": "f536",
	"./fr.json": "d8db",
	"./id.json": "f760",
	"./it.json": "d721",
	"./jp.json": "c721",
	"./kr.json": "23db",
	"./pt.json": "0a84",
	"./th.json": "9f4e",
	"./zh-TW.json": "0c62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db95";